import React from 'react';
import config from 'config';
import './LazyLoadingIndicator.scss';

function LazyLoadingIndicator(props) {
  return (
    <div class="lazy-loading-indicator">
      <div className="lazy-loading-indicator-icon">
        <img
          src={`${config.STATIC_BASE_URL}/images/loading_gray.png`}
          alt="loading"
        />
      </div>
    </div>
  );
}

export default LazyLoadingIndicator;
